<template>
  <section class="app-main">
    <router-view :key="$route.fullPath" />

    <video id="remoteVideo"></video>
    <video id="localVideo" muted="muted"></video>

    <ImportServicesDrawer :visible="importServicesDrawer" />
  </section>
</template>

<script>
import ImportServicesDrawer from "@/modules/importservices/components/ImportServicesDrawer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppMain",

  data() {
    return {};
  },

  components: {
    ImportServicesDrawer,
  },

  computed: {
    ...mapGetters("app", ["defaultWorkgroup", "workgroups", "importServicesDrawer"]),
  },

  methods: {
    ...mapActions("clientConfigs", ["getConfigs"]),
    ...mapActions("clientStreets", ["checkStreetsErrors"]),
    ...mapActions("clientStopszones", ["checkStopsErrors"]),
  },

  created() {
    this.getConfigs({
      idWg: this.defaultWorkgroup.id,
      name: "deliveryMode",
    });
    // this.checkStreetsErrors(this.workgroups.map((wg) => wg.id));
    // this.checkStopsErrors(this.workgroups.map((wg) => wg.id));
  },

  mounted() {
    // workaround to skip "select user" dialog on chrome based browsers
    delete Object.getPrototypeOf(navigator).credentials;
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  min-height: 500px;
  width: 100%;
  position: relative;
  overflow: hidden;
  height: calc(100vh - var(--topbar-height)) !important;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

#remoteVideo,
#localVideo {
  position: absolute;
  right: 0;
  z-index: 0;
}
</style>
